/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Tea_Purchases_ListInputs */

const vi_nav_tea_purchases_list = /** @type {(inputs: Nav_Tea_Purchases_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Danh sách đơn mua`)
};

/**

* @param {Nav_Tea_Purchases_ListInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const nav_tea_purchases_list = /** @type {((inputs?: Nav_Tea_Purchases_ListInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Tea_Purchases_ListInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_nav_tea_purchases_list(inputs)
});